import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-material-design-icon-size',
	templateUrl:'./MaterialDesignIconSizePluginCompPage.html',
	styles: [],
	styleUrls:['./MaterialDesignIconSizePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialDesignIconSizePluginCompPage
{
	mdContent_1070 = `\`\`\`java
import com.jwebmp.plugins.materialdesignicons.MaterialDesignIconSize;
\`\`\``;
}
